import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { IMAGE_BASE_URL } from "../data/baseURL";
import reviewImg from "../images/CUSTOMERS.png";
import { Rating } from "./rating";

const Review = ({ reviewSliders, review }) => {
  const navigate = useNavigate();
  return (
    <section className="">
      <div className="container-fluid pt-13">
        <div className="ms-13 me-13">
          <div className="position-relative text-center">
            <h1 className="fs-56 gilroy-bold text-center review-h1 mb-5 pb-4">
              Our customer <br /> Loves what we do
            </h1>
            <div className="position-absolute mx-auto start-0 end-0 text-center review-img-position">
              <img
                src={reviewImg}
                className="img-fluid"
                loading="lazy"
                alt=""
              />
            </div>
          </div>
          <div className="container pt-7">
            <div className="row">
              {reviewSliders?.slice(0, 6)?.map((reviewSide, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4 mb-5">
                  <div
                    className="bg-white p-3 rounded-lg mb-5 review-shadow position-relative transform-up h-100 cursor-pointer"
                    onClick={() =>
                      navigate(`/clients/project/${reviewSide?.id}`)
                    }
                  >
                    <div className="d-flex justify-content-center">
                      <img
                        src={`${IMAGE_BASE_URL}/${reviewSide?.image}`}
                        alt="user"
                        className="img-fluid d-block mx-auto my-3"
                      />
                    </div>
                    <div className="text-center mt-3 px-3">
                      <h3 className="fs-18 gilroy-bold text-secondary">
                        {reviewSide?.title}
                      </h3>

                      <div className="d-flex justify-content-center">
                        <Rating />
                      </div>
                      <p
                        className="fs-16 mt-3 mb-4 text-spanish-gray text-align-justify"
                        dangerouslySetInnerHTML={{
                          __html: reviewSide?.description,
                        }}
                      />
                    </div>
                    <div className="review-card-border"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="text-center my-5">
            <Link
              to="/clients"
              className="text-decoration-none bg-american-yellow px-5 d-inline-block py-4 fs-14 text-white mb-5 text-uppercase"
            >
              View More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Review;
